<template>
  <div v-if="isPresent(cancellation)" class="mt-6 rounded-xl bg-gray-50 p-5">
    <h2 class="text-lg font-semibold mb-4">Résiliation</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
      <div class="space-y-2">
        <StackedField label="Date" :value="cancellation.date" />
        <StackedField label="Date fin d'encaissement" :value="cancellation.billingEndDate" />
        <StackedField label="Type" :value="cancellation.cancellationType ? $t(cancellation.cancellationType) : ''" />
        <StackedField
          label="Résilié par"
          :value="cancellation.initiatedBy ? $t('Cancellation initiated by.' + cancellation.initiatedBy) : ''"
        />
      </div>
      <div class="space-y-2 mt-1 md:mt-0">
        <StackedField
          label="Raison"
          :value="cancellation.reason ? $t('Plan cancellation reasons.' + cancellation.reason) : ''"
        />
        <StackedField label="Expérience" :value="cancellation.feedbackExperience" />
        <StackedField label="Message" :value="cancellation.feedbackMessage" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, isPresent } from "@estaly/ui";

export default {
  components: {
    StackedField,
  },

  props: ["cancellation"],

  methods: {
    isPresent,
  },
};
</script>
